export const GET_LOGS_START = "GET_LOGS_START";
export const GET_LOGS_END = "GET_LOGS_END";

export const GET_FILTERED_USER_LOGS = "GET_FILTERED_USER_LOGS";
export const GET_USER_LOGS = "GET_USER_LOGS";
export const GET_USER_LOGS_END = "GET_USER_LOGS_END";
